import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Typography, Table, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;

function StockItems() {

    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const navigate = useNavigate();
    const { stockid } = useParams();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [StockItems, setStockItems] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editStockItem, setEditStockItem] = useState(null);
    const [filteredStockItems, setFilteredStockItems] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [products, setProducts] = useState([]);


    const fetchCategoryDetails = () => {

        const storedCategoryName = localStorage.getItem(`stockName_${stockid}`);
        if (storedCategoryName) {
            setCategoryName(storedCategoryName);
        } else {
            setCategoryName('Category ' + stockid);
        }
    };

    useEffect(() => {
        if (stockid) {
            setStockItems([]);
            setFilteredStockItems([]);
            setKeyword('');
            fetchCategoryDetails();
            fetchStockItems();
        }

    }, [stockid]);

    const fetchStockItems = async () => {
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/stocks/stockitemslist/${stockid}`, { headers });
            setStockItems(response.data);
            setFilteredStockItems(response.data);
        } catch (error) {
            AlertError("Failed to fetch StockItems");
        }
    };

    const showModal = async () => {
        setIsModalOpen(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/products/dropdown/${'all'}`, { headers });
            setProducts(response.data);
        } catch (error) {
            AlertError("Failed to fetch products");
        }
    };


    const showEditModal = (stockItem) => {
        setEditStockItem(stockItem);
        form.setFieldsValue({
            stockItemName: stockItem.itemName,
            availableQty: stockItem.availableQty,
            warehouseRack: stockItem.warehouseRack,
            warehouseRow: stockItem.warehouseRaw,
            reOrderQty: stockItem.reorderQty,
            status: stockItem.stockItemActive
        });
        setIsEditModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    const handleCreateStockItem = async () => {
        try {
            const values = await form.validateFields();

            const requestData = {
                stockId: stockid,
                productId: String(values.productId),
                availableQty: String(values.availableQty),
                warehouseRack: values.warehouseRack,
                warehouseRow: values.warehouseRow,
                reOrderQty: values.reOrderQty,
                createdBy: UPDATED_BY
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(`${ApiURL}/stocks/additem`, requestData, { headers });

            if (response.status === 200) {
                AlertSuccess("Item successfully added to stock!");
                handleCancel();
                fetchStockItems();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add stock item!");
        }
    };

    const handleUpdateStockItem = async () => {
        try {
            const values = await form.validateFields();

            const requestData = {
                itemId: String(editStockItem.stockItemId),
                warehouseRack: String(values.warehouseRack),
                warehouseRow: String(values.warehouseRow),
                reOrderQty: String(values.reOrderQty),
                status: values.status
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json"
            };

            const response = await axios.post(
                `${ApiURL}/stocks/edititem`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("StockItem successfully updated!");
                handleCancel();
                fetchStockItems();
            }
        } catch (error) {

            AlertError(error.response?.data?.message || "Failed to update stockItem!");
        }
    };

    const handleDeleteStockItem = async (id) => {
        try {

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json"
            };

            // Using the exact API endpoint format specified
            const response = await axios.get(
                `${ApiURL}/master/stockItem/delete/${id}`,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("StockItem deleted successfully!");
                fetchStockItems(); // Refresh the list
            } else {
                AlertError("Failed to delete stockItem. Unexpected response.");
            }
        } catch (error) {

            AlertError(error.response?.data?.message || "Failed to delete stockItem!");
        }
    };

    const handleFilter = () => {
        if (keyword) {
            const lowerKeyword = keyword.toLowerCase();
            const filtered = StockItems.filter(stockItem =>
                // FIXED: Changed from subCategoryName to itemName/itemSku to prevent crash and actually filter
                (stockItem.itemName && stockItem.itemName.toLowerCase().includes(lowerKeyword)) ||
                (stockItem.itemSku && stockItem.itemSku.toLowerCase().includes(lowerKeyword))
            );
            setFilteredStockItems(filtered);
        } else {
            setFilteredStockItems(StockItems);
        }
    };

    const handleReset = () => {
        setKeyword('');
        setFilteredStockItems(StockItems);
    };

    const goBackToCategories = () => {
        navigate('/stocks/management');
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                </Space>
            ),
        },
        {
            title: 'SKU',
            dataIndex: 'itemSku',
            key: 'itemSku',
            sorter: (a, b) => (a.itemSku || '').localeCompare(b.itemSku || ''),
            align: "center",
        },
        {
            title: 'Item Name',
            dataIndex: 'itemName',
            key: 'itemName',
            sorter: (a, b) => (a.itemName || '').localeCompare(b.itemName || ''),
            align: "center",
        },
        {
            title: 'Available',
            dataIndex: 'availableQty',
            key: 'availableQty',
            sorter: (a, b) => (parseFloat(a.availableQty) || 0) - (parseFloat(b.availableQty) || 0),
            align: "center",
        },
        {
            title: 'Reorder Qty',
            dataIndex: 'reorderQty',
            key: 'reorderQty',
            sorter: (a, b) => (parseFloat(a.reorderQty) || 0) - (parseFloat(b.reorderQty) || 0),
            align: "center",
        },
        {
            title: 'warehouse Rack',
            dataIndex: 'warehouseRack',
            key: 'warehouseRack',
            sorter: (a, b) => (a.warehouseRack || '').localeCompare(b.warehouseRack || ''),
            align: "center",
        },
        {
            title: 'warehouse Row',
            dataIndex: 'warehouseRaw',
            key: 'warehouseRaw',
            sorter: (a, b) => (a.warehouseRaw || '').localeCompare(b.warehouseRaw || ''),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'stockItemActive',
            key: 'stockItemActive',
            render: (stockItemActive) => (
                <Tag color={stockItemActive === true ? "green" : "red"}>
                    {stockItemActive === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item><Link to={'/stocks/management'}>Stocks Management</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Stock Items</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Col>
                                <Typography.Title level={4} style={{ margin: 0 }}>
                                    Stock : {categoryName}
                                </Typography.Title>
                            </Col>
                            <Col>
                                <Space>
                                    <Button
                                        type="default"
                                        icon={<ArrowLeftOutlined />}
                                        onClick={goBackToCategories}
                                    >
                                        Go back to Stocks
                                    </Button>
                                    <Button type="primary" onClick={showModal}>Add New</Button>
                                </Space>
                            </Col>
                        </Row>

                        <Row style={{ display: "flex", justifyContent: 'space-between', marginBottom: '15px' }}>
                            <Col xs={24} md={12}>
                                <Input
                                    placeholder="Search by SKU or Item Name"
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </Col>
                            <Col xs={24} md={8} style={{ display: "flex", justifyContent: 'flex-end' }} className="mt-2 mt-md-0">
                                <Button type="primary" onClick={handleFilter} style={{ width: "50%", margin: "0" }}>Filter</Button>
                                <Button style={{ marginLeft: '10px', width: "50%" }} onClick={handleReset}>Reset</Button>
                            </Col>
                        </Row>
                        <Typography.Title level={5}>List of StockItems for {categoryName}</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredStockItems}
                            rowKey="stockItemId" 
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />
                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New StockItem"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateStockItem}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} initialValues={{ availableQty: 0, }} layout="vertical">
                    <Form.Item
                        label="Select Product"
                        name="productId"
                        rules={[{ required: true, message: "Product is required" }]}
                    >
                        <Select
                            showSearch
                            placeholder="Select a product"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {products.map((product) => (
                                <Option key={product.id} value={product.id}>
                                    {product.label}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Available Quantity"
                        name="availableQty"
                        rules={[{ required: true, message: "Available quantity is required" }]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item label="Warehouse Rack" name="warehouseRack">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Warehouse Row" name="warehouseRow">
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Re-order Quantity"
                        name="reOrderQty"
                        rules={[{ required: true, message: "Re-order quantity is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>

            </Modal>

            <Modal
                title="Edit StockItem"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateStockItem}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="StockItem Name"
                        name="stockItemName"
                        rules={[{ required: true, message: "StockItem name is required" }]}

                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Available Quantity"
                        name="availableQty"
                        rules={[{ required: true, message: "Available quantity is required" }]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item label="Warehouse Rack" name="warehouseRack">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Warehouse Row" name="warehouseRow">
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Re-order Quantity"
                        name="reOrderQty"
                        rules={[{ required: true, message: "Re-order quantity is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Active Status"
                        name="status"
                        valuePropName="checked"
                    >
                        <Switch />
                    </Form.Item>
                </Form>
            </Modal>
        </Layout>
    );
}

export default StockItems;